// dashboard.regions.tsx
// Route parente : /dashboard/regions — layout partagé par la liste des régions
// (dashboard.regions.index.tsx) et le détail d'une région (dashboard.regions.$regionId.tsx).
// IMPORTANT : ce fichier DOIT rendre <Outlet /> — sans lui, TanStack Router
// matche bien la route enfant /dashboard/regions/$regionId (l'URL change) mais
// n'affiche jamais son contenu, car c'est le parent qui est rendu à sa place.

import { createFileRoute, Outlet } from "@tanstack/react-router";

import { AppLayout } from "@/presentation/layouts/AppLayout";

export const Route = createFileRoute("/dashboard/regions")({
  component: function DashboardRegionsLayoutComponent() {
    return (
      <AppLayout>
        <Outlet />
      </AppLayout>
    );
  },
});
